import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../assets/css/Header.css";

const Header = () => {

    const [menuOpen, setMenuOpen] = useState(false);

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    const closeMenu = () => {
        setMenuOpen(false);
    };

    return (

        <nav className="hero-nav">

            <Link to="/" className="logo">
                Indrajeet Patil
            </Link>

            {/* HAMBURGER */}

            <div
                className={`hamburger ${menuOpen ? "active" : ""}`}
                onClick={toggleMenu}
            >
                <span></span>
                <span></span>
                <span></span>
            </div>

            {/* MENU */}

            <ul className={`nav-links ${menuOpen ? "open" : ""}`}>

                <li className="active" onClick={closeMenu}>
                    <Link to="/">Home</Link>
                </li>

                <li onClick={closeMenu}>
                    <Link to="/about">About</Link>
                </li>

                <li onClick={closeMenu}>
                    <Link to="/gallery">Gallery</Link>
                </li>

                <li onClick={closeMenu}>
                    <Link to="/blog">Blog</Link>
                </li>

                <li onClick={closeMenu}>
                    <Link to="/contact">Contact</Link>
                </li>

            </ul>

        </nav>

    );
};

export default Header;